import React, { Component } from 'react'
import MemoContent from './MemoContent'
import './style.css'


export default class Memo extends Component {

	state = { eMenu : 'business' }


    menuFx = (e) => {

        this.setState({ eMenu : e.target.id })

    }


    render() {

        const WrapperStyle = {
            backgroundImage : 'url("/memo.jpg")',
            minHeight : '100vh',
            backgroundPosition : 'center',
            backgroundRepeat : 'no-repeat',
            backgroundSize : 'cover',
            backgroundAttachment : 'fixed'
        }


        return (

            <div style={WrapperStyle}>

                <div className='MemoMenuContainer'>

                    <span id='personal' style={{opacity : this.state.eMenu === 'personal' ? 1 : 0.8 }} onClick={this.menuFx}>Personal</span>
                    <span id='learning' style={{opacity : this.state.eMenu === 'learning' ? 1 : 0.8 }} onClick={this.menuFx}>Learning</span>
                    <span id='business' style={{opacity : this.state.eMenu === 'business' ? 1 : 0.8 }} onClick={this.menuFx}>Business</span>
                		
                </div>

                <MemoContent catg1={ this.state.eMenu } isLogin={ this.props.isLogin } />

                <div className='ClearFix'></div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/memo/index.js